import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const NoEmployeesIllustration = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="164"
        height="116"
        viewBox="0 0 164 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M8 35.5H112C113.933 35.5 115.5 37.067 115.5 39V78C115.5 79.933 113.933 81.5 112 81.5H8C6.067 81.5 4.5 79.933 4.5 78V39C4.5 37.067 6.067 35.5 8 35.5Z"
          fill="#F7F9FB"
          stroke="#EDEFF6"
        />
        <path
          opacity="0.5"
          d="M52 35.5H156C157.933 35.5 159.5 37.067 159.5 39V78C159.5 79.933 157.933 81.5 156 81.5H52C50.067 81.5 48.5 79.933 48.5 78V39C48.5 37.067 50.067 35.5 52 35.5Z"
          fill="#F7F9FB"
          stroke="#EDEFF6"
        />
        <g filter="url(#no_employees_illustration_shadow)">
          <path
            d="M30 30C30 27.7909 31.7909 26 34 26H130C132.209 26 134 27.7909 134 30V86C134 88.2091 132.209 90 130 90H34C31.7909 90 30 88.2091 30 86V30Z"
            fill="white"
          />
          <path
            d="M34 26.5H130C131.933 26.5 133.5 28.067 133.5 30V86C133.5 87.933 131.933 89.5 130 89.5H34C32.067 89.5 30.5 87.933 30.5 86V30C30.5 28.067 32.067 26.5 34 26.5Z"
            stroke="#EDEFF6"
          />
        </g>
        <circle cx="52" cy="60" r="14" fill="#EDEFF6" />
        <path
          d="M73 53C73 51.3431 74.3431 50 76 50H117C118.657 50 120 51.3431 120 53C120 54.6569 118.657 56 117 56H76C74.3431 56 73 54.6569 73 53Z"
          fill="#EDEFF6"
        />
        <path
          d="M73 67C73 65.3431 74.3431 64 76 64H102C103.657 64 105 65.3431 105 67C105 68.6569 103.657 70 102 70H76C74.3431 70 73 68.6569 73 67Z"
          fill="#EDEFF6"
        />
        <defs>
          <filter
            id="no_employees_illustration_shadow"
            x="14"
            y="16"
            width="136"
            height="96"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="6" />
            <feGaussianBlur stdDeviation="8" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.36 0 0 0 0 0.4 0 0 0 0 0.55 0 0 0 0.16 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_0_19"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_0_19"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </Center>
  );
};
